import "core-js/modules/es.json.stringify.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "用户注册", -1);

var _hoisted_2 = /*#__PURE__*/_createTextVNode("注册");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

import { ref, unref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import VerificationCode from "@/components/VerificationCode.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _getCurrentInstance = getCurrentInstance(),
        ctx = _getCurrentInstance.ctx,
        proxy = _getCurrentInstance.proxy;

    var router = useRouter();
    var loginRef = ref();
    var loginForm = ref({
      account: "",
      code: "",
      password: "",
      checkPassword: ""
    });

    var validatePass = function validatePass(rule, value, callback) {
      if (loginForm.value.password === loginForm.value.checkPassword) {
        callback();
      } else {
        callback(new Error("两次密码必须一致..."));
      }
    };

    var rules = ref({
      account: [{
        required: true,
        message: "账号不能为空...",
        trigger: "blur"
      }, {
        type: "email",
        min: 5,
        max: 30,
        message: "账号必须是5-30位邮箱格式...",
        trigger: ["blur", "change"]
      }],
      code: [{
        required: true,
        message: "验证码不能为空...",
        trigger: ["blur", "change"]
      }, {
        len: 6,
        message: "验证码只能是6位...",
        trigger: ["blur", "change"]
      }],
      password: [{
        type: "string",
        required: true,
        message: "密码不能为空且只允许数字字母组合...",
        pattern: /^[0-9A-Za-z]+$/,
        trigger: ["blur", "change"]
      }, {
        min: 6,
        max: 18,
        message: "密码必须是6-18位...",
        trigger: ["blur", "change"]
      }],
      checkPassword: [{
        type: "string",
        required: true,
        message: "密码不能为空且只允许数字字母组合...",
        pattern: /^[0-9A-Za-z]+$/,
        trigger: ["blur", "change"]
      }, {
        min: 6,
        max: 18,
        message: "密码必须是6-18位...",
        trigger: ["blur", "change"]
      }, {
        validator: validatePass,
        trigger: ["blur", "change"]
      }]
    });

    var submitForm = function submitForm() {
      var form = unref(loginRef);
      form.validate(function (valid) {
        if (valid) {
          proxy.$axios.post("/api/register", loginForm.value).then(function (res) {
            ElMessage({
              message: "登录成功!",
              type: "success"
            });
            localStorage.setItem("userInfo", JSON.stringify(res.result));
            localStorage.setItem("token", res.result.token);
            router.push("/admin");
          });
        } else {
          ElMessage.error("参数校验错误.");
          return false;
        }
      });
    };

    var resetForm = function resetForm() {
      var form = unref(loginRef);
      form.resetFields();
    };

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_el_form, {
        ref_key: "loginRef",
        ref: loginRef,
        model: loginForm.value,
        rules: rules.value,
        "label-width": "120px"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "邮箱",
            prop: "account"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                placeholder: "请输入邮箱...",
                modelValue: loginForm.value.account,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return loginForm.value.account = $event;
                }),
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            prop: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(VerificationCode, {
                mail: loginForm.value.account
              }, null, 8, ["mail"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "验证码",
            prop: "code"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                placeholder: "请输入验证码...",
                modelValue: loginForm.value.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return loginForm.value.code = $event;
                }),
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码",
            prop: "password"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                placeholder: "请输入密码...",
                modelValue: loginForm.value.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return loginForm.value.password = $event;
                }),
                type: "password",
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "确认密码",
            prop: "checkPassword"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                placeholder: "请再次输入密码...",
                modelValue: loginForm.value.checkPassword,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return loginForm.value.checkPassword = $event;
                }),
                type: "password",
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return submitForm();
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                onClick: resetForm
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model", "rules"])], 64);
    };
  }
});